import {
  type AuthError,
  confirmResetPassword as _confirmResetPassword,
  confirmSignIn as _confirmSignIn,
  resetPassword as _resetPassword,
  signIn as _signIn,
  updatePassword as _updatePassword,
} from "aws-amplify/auth";

import type { EnumObjectToUnion } from "../../utils/enum";
import { isEnumMember } from "../../utils/enum";

import {
  ChangePasswordException,
  ConfirmForgotPasswordException,
  ConfirmSignUpException,
  ForgotPasswordException,
  InitiateAuthException,
} from "./amplify-errors/exceptions";

type AmplifyAuthError<TName extends string> = AuthError & { name: TName };

function withHandleAmplifyException<
  TArgs extends unknown[],
  TReturn,
  TErrors extends Record<string, string>,
>(fn: (...args: TArgs) => Promise<TReturn>, errors: TErrors) {
  return async (...args: TArgs) => {
    try {
      const ret = await fn(...args);
      return { data: ret, error: undefined };
    } catch (error) {
      if (!(error instanceof Error && isEnumMember(errors, error.name)))
        throw error;
      return {
        data: undefined,
        error: error as AmplifyAuthError<EnumObjectToUnion<TErrors>>,
      };
    }
  };
}

export const signIn = withHandleAmplifyException(
  _signIn,
  InitiateAuthException,
);

export const confirmSignIn = withHandleAmplifyException(
  _confirmSignIn,
  ConfirmSignUpException,
);

export const updatePassword = withHandleAmplifyException(
  _updatePassword,
  ChangePasswordException,
);

export const resetPassword = withHandleAmplifyException(
  _resetPassword,
  ForgotPasswordException,
);

export const confirmResetPassword = withHandleAmplifyException(
  _confirmResetPassword,
  ConfirmForgotPasswordException,
);

// MFA認証コードの再送はCognitoのAPIが提供されていないため、signInの再実行を行う
export const resendSignInCode = withHandleAmplifyException(
  _signIn,
  InitiateAuthException,
);
